// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Future from "reason-future/src/Future.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Config$LiveRoom from "../../Config.bs.js";
import * as Utils_User$LiveRoom from "./Utils_User.bs.js";
import * as GraphQLClient$LiveRoom from "../GraphQLClient.bs.js";
import * as Utils_Logging$LiveRoom from "./Utils_Logging.bs.js";
import * as FeatureFlagStore$LiveRoom from "../stores/FeatureFlagStore.bs.js";

function checkForId(getUserIdSummaryOpt, me, param) {
  var getUserIdSummary = getUserIdSummaryOpt !== undefined ? getUserIdSummaryOpt : GraphQLClient$LiveRoom.getUserIdSummary;
  var match = me.authToken;
  var isAuthenticated;
  if (typeof match === "object") {
    var variant = match.NAME;
    isAuthenticated = variant === "AuthenticatedForPreview" ? true : (
        variant === "Authenticated" ? match.VAL.details.userType !== "basic" : false
      );
  } else {
    isAuthenticated = false;
  }
  var match$1 = Curry._1(FeatureFlagStore$LiveRoom.IdRestriction.getExperimentGroup, undefined) !== "On" && Config$LiveRoom.tier !== "Prod";
  if (match$1 || !isAuthenticated) {
    return Future.value(undefined, {
                status: /* Success */0
              });
  } else {
    return Future.map(Curry._1(getUserIdSummary, Utils_User$LiveRoom.tokenValue(me)), (function (result) {
                  if (result.TAG === /* Ok */0) {
                    var response = result._0;
                    var response$1;
                    var variant = response.NAME;
                    if (variant === "Error") {
                      Utils_Logging$LiveRoom.log(Caml_option.some(Js_dict.fromList({
                                    hd: [
                                      "error",
                                      Belt_Option.getWithDefault(JSON.stringify(response.VAL), "")
                                    ],
                                    tl: /* [] */0
                                  })), undefined, undefined, "Failed fetching UserHasId query failed");
                      return {
                              status: /* Error */5
                            };
                    }
                    response$1 = variant === "Data" ? response.VAL : response.VAL[0];
                    var match = Belt_Option.map(response$1.me.identityDocumentSummary, (function (summary) {
                            return [
                                    summary.reason,
                                    summary.uploadRequired
                                  ];
                          }));
                    if (match === undefined) {
                      return {
                              status: /* FirstTime */2
                            };
                    }
                    var match$1 = match[0];
                    if (match$1 !== undefined) {
                      if (match$1 === "NO_REASON") {
                        return {
                                status: /* Success */0
                              };
                      } else if (match$1 === "NO_ID") {
                        return {
                                status: /* FirstTime */2
                              };
                      } else if (match$1 === "ID_REJECTED") {
                        return {
                                status: /* Rejected */3
                              };
                      } else if (match$1 === "ID_EXPIRED") {
                        return {
                                status: /* Expired */4
                              };
                      } else {
                        return {
                                status: /* Pending */1
                              };
                      }
                    } else if (match[1]) {
                      return {
                              status: /* FirstTime */2
                            };
                    } else {
                      return {
                              status: /* Success */0
                            };
                    }
                  }
                  Utils_Logging$LiveRoom.log(Caml_option.some(Js_dict.fromList({
                                hd: [
                                  "error",
                                  Belt_Option.getWithDefault(JSON.stringify(result._0), "")
                                ],
                                tl: /* [] */0
                              })), undefined, undefined, "Failed fetching UserHasId query failed");
                  return {
                          status: /* Error */5
                        };
                }));
  }
}

export {
  checkForId ,
}
/* Config-LiveRoom Not a pure module */
